/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const btnWrapperStyles = css({
    marginTop: 'auto',
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
});

const editBtnStyles = ({ isDisabled }: { isDisabled: boolean }) => {
    return css({
        '@media (hover: hover) and (pointer: fine)': {
            '&:hover': isDisabled
                ? 'none'
                : {
                      backgroundColor: '#40a7e3',
                      color: '#ffffff',
                      opacity: '0.7',
                      transition: 'all 0.3s ease-out',
                  },
        },
        cursor: isDisabled ? 'default' : 'pointer',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px 15px',
        width: '100%',
        height: '36px',
        backgroundColor: isDisabled ? 'lightgray' : '#40a7e3',
        borderRadius: '5px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '14px',
        color: '#ffffff',
        textTransform: 'none',
        transition: 'all 0.3s ease-out',
    });
};

const styles = {
    btnWrapperStyles,
    editBtnStyles,
};

export default styles;
